import axios from 'axios';
import React , {useState , useEffect } from 'react'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Button, Checkbox, InputWrapper } from '../../../Components';

export function EditPermissionsTeamMember({
		onSuccess = () => {} 
	}) {
	
		const regex_validator = {
			email : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		}	
	
		const {  user_id } = useParams();
		const navigate = useNavigate();
        const { user , org } = useSelector((state) => state.auth)
	
		const [formData, setFormData] = useState({
			pages : [] 
			 
		});
		const [formValidation, setFormValidation] = useState({
			pages : ""
	
		})
		const [statuspages, setStatusPages] = useState([])
		const [profileUser, setProfileUser] = useState({})
		const [isLoading, setIsLoading] = useState(false)
	
		useEffect( () => {
			
			async function fetchData() {
				
				// Get the available component groupes 
				await getUserData()
				.then((USER) => {
					getStatuspages(USER);
				});
	
			}
			fetchData();
		}, [])

		 
	
		/**
		 * 
		 * @returns 
		 */
		const getStatuspages = (USER_DATA) => {
			return new Promise(async(resolve, reject) => { 
	
				setIsLoading(true)
				
				
				
				
				if (user && user.token && org && org?.id ) {
					
					let params = { 
						page : 0,
						per_page : -1
	
					}
	
					const token = user?.token;
	
	
					await axios.get(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/statuspages` , {
						params :params,
						headers: {
							'Authorization': `Bearer ${token}`
						},
					})
					.then( res => res.data )
					.then( data => {
	
						setStatusPages(data.data)

						let _pages = [ ...formData?.pages ]
						if(USER_DATA && USER_DATA?.statuspages){
							
							const userPageIds = USER_DATA?.statuspages?.map( x=> (x.id))
							_pages = data.data.filter( x => userPageIds?.includes(x?.id))?.map( page => ({
								id : page?.id,
								name : page?.name ,
								access : 'READ_WRITE',
								checked : true 
							}))

	
	
							setFormData( prevState => ({
								...prevState ,
								pages : _pages
							}))
						}
	
						setIsLoading(false)
			
						resolve(data.data) 
			
					})
					.catch(error => {
						//console.log(error);
						if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
							navigate('/signout')
						}
						setIsLoading(false)
						if (error.response) {
							if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
							
								setStatusPages([])
							}
							reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
						} else {
							// Something happened in setting up the request that triggered an Error
							if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. thank you try later.`)
							}
						}
					})
				}else{
					setIsLoading(false)
				}
	
			})
		}


		const getUserData = () => {
			return new Promise(async(resolve, reject) => { 
	
				setIsLoading(true)
				
				
				
				
				if (user && user.token && org && org?.id ) {
					
					let params = { 
						
	
					}
	
					const token = user?.token;
	
	
					await axios.get(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/team/${user_id}` , {
						params :params,
						headers: {
							'Authorization': `Bearer ${token}`
						},
					})
					.then( res => res.data )
					.then( data => {
	
						setProfileUser(data)
						 
	
						setIsLoading(false)
			
						resolve(data) 
			
					})
					.catch(error => {
						if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
							navigate('/signout')
						}
						setIsLoading(false)
						if (error.response) {
							if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
							
								setProfileUser({})
							}
							reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
						} else {
							// Something happened in setting up the request that triggered an Error
							if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. thank you try later.`)
							}
						}
					})
				}else{
					setIsLoading(false)
				}
	
			})
		}
	
		/**
		 * SAVE COMPONENT 
		 */
		const onSubmit = async (e) => {
			e.preventDefault();
	
			return new Promise( async (resolve, reject) => { 
				
				setIsLoading(true)
				setFormValidation((prevState) => ({
					...prevState,
					pages : formData?.pages.length <= 0 ? 'No status page has been selected' : ''
				}))
	
	
	
				if( formValidation?.pages !=='' ){
	
					toast.error("Please complete all required fields")
					setIsLoading(false)
	
					return 
				}
	
				
				
				
				
				
				if (user && user.token && org && org?.id ) {
					
					let params = { 
						statuspages : formData?.pages
					}
	
					const token = user?.token;
	
	
					await axios.put(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/team/${user_id}`, params , {
						headers : {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${token}`,//'JWT token...'
						}
					} )
					.then( res => res.data )
					.then( data => {
	
						setIsLoading(false)
	
						toast.success('Your user has been successfully invited') 
	
						onSuccess({
							access : data?.access,
							claimed : data?.claimed,
							created_at : data?.created_at,
							expiry_date : data?.expiry_date,
							id : data?.id,
							invited_email : data?.email,
							organization_id : data?.organization_id,
							organization : data?.organization,
							type : "MEMBER",
							updated_at : null ,
							statuspages : data?.statuspages,
						})
	
						onCloseForm();
			
						resolve(data.data) 
			
					})
					.catch(error => {
						//console.log(error);
						if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
							navigate('/signout')
						}
						setIsLoading(false)
						if (error.response) {
							if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
							
								 
							}
							reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
						} else {
							// Something happened in setting up the request that triggered an Error
							if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. thank you try later.`)
							}
						}
	
						toast.error('Something went wrong, please try again later.') 
					})
				}else{
					setIsLoading(false)
					toast.error('Something went wrong, please try again later.') 
				}
	
	
			})
	
		}
	
		/**
		 * 
		 * @param {*} e 
		 */
		const onChange = (e) => {
	
			switch(e.target.name){
				case "email" : 
					setFormValidation((prevState) => ({
						...prevState,
						email :  (e.target.value.match(regex_validator.email)===null) ? 'Invalid email address' : ''
					}))
					
					break;
				
			}
	
			setFormData((prevState) => ({
				...prevState,
				[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
			}));
		};
	
	
		
		/**
		 * 
		 * @param {*} e 
		 */
		const onChangeStatusPage = (SELECTED_OBJ) => {

			//console.log('SELECTED_OBJ : ' , SELECTED_OBJ)
	
			const results_pages = SELECTED_OBJ?.checked === true 
									? [...formData.pages , SELECTED_OBJ] // add item  
									: formData?.pages?.filter(x => x.id !== SELECTED_OBJ?.id ) // remove item ,
			
			setFormData((prevState) => ({
				...prevState,
				pages: results_pages
			}));
			setFormValidation((prevState) => ({
				...prevState,
				pages : results_pages.length <= 0 ? 'No status page has been selected' : ''
			}))
		}
	
		const onCloseForm = () => {
			navigate(`/team`)	
		}		

	return (
		<form onSubmit={onSubmit}>
			<p>Manage access controls over your organization. Define which pages a user will have access to.</p>
			<InputWrapper 
				label="Page permissions" mb={15}
				error={formValidation?.pages}
				>
				{
					isLoading === true 
					? 'Loading ...'
					: (
						statuspages.length <= 0 
						? <Alert>No status page found</Alert>
						: statuspages?.map( (page , index) => {
							 
							return (
								<Checkbox 
									key={index}
									name={page?.id}
									label={page?.name}
									onChange={(e) => onChangeStatusPage({
										id : page?.id,
										name : page?.name ,
										access : 'READ_WRITE',
										checked : e.target.checked
									})} 
									checked={formData?.pages.findIndex(x => x.id === page?.id) >=0 ? true : false }
									/>

							)
						}))
				}
			</InputWrapper>
			<div className="field-group submit-fields-group"   >
				<Button className="" color="gray" variant="default" onClick={onCloseForm} >Back</Button>
				<Button className="ml-10" onClick={onSubmit} loading={isLoading}>Update</Button>
			</div>
		</form>
	)
}
